// extracted by css-extract-rspack-plugin
export default {"container":"_99b415ef","grid":"_d5de4710"};